export const baseUrl = "https://api.veeuapp.ir/api"
export const baseUrlWithoutApi = "https://api.veeuapp.ir"


/*
export const baseUrl = "https://localhost:7292/api"
export const baseUrlWithoutApi = "https://localhost:7292"
 */